module.exports = __webpack_public_path__ + "c615e50211f2c37f6ede03f6d64bfcf3.svg";